module.exports = __webpack_public_path__ + "img/pr-28.31478e71.png";